import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants'

import { PlpSearchParams } from '../types'

type FacetItem = {
    key?: string | null
    value?: string | null
}

interface Props {
    searchParams: PlpSearchParams
    facetItems?: FacetItem[] | null
}

export function applyDefaultFacetValues({ searchParams, facetItems }: Props) {
    const dynamicFacetKey = PRODUCT_QUERY_PARAMS.DYNAMIC_FACET
    const existingFacets = searchParams[dynamicFacetKey]
    const mergedFacetValues: string[] = []

    if (Array.isArray(existingFacets)) {
        mergedFacetValues.push(
            ...existingFacets.filter((value): value is string => typeof value === 'string' && !!value)
        )
    } else if (typeof existingFacets === 'string' && existingFacets) {
        mergedFacetValues.push(existingFacets)
    }

    const defaultFacets =
        facetItems
            ?.filter((f): f is Required<FacetItem> => !!f.key && !!f.value)
            .map(({ key, value }) => `facetKey.${key}:${value}`) ?? []

    for (const facetValue of defaultFacets) {
        if (!mergedFacetValues.includes(facetValue)) {
            mergedFacetValues.push(facetValue)
        }
    }

    const updatedSearchParams = { ...searchParams }

    if (mergedFacetValues.length > 0) {
        updatedSearchParams[dynamicFacetKey] = mergedFacetValues.length === 1 ? mergedFacetValues[0] : mergedFacetValues
    } else {
        delete updatedSearchParams[dynamicFacetKey]
    }

    return updatedSearchParams
}
